



















// vendor
import { defineComponent, PropType, set, computed } from "@vue/composition-api";
// local
import { SelectParams } from "../../ts/templates/Select";

import { useTranslate } from "@lang";
import { Container } from "@ui";


export default defineComponent({

	props:{
		parameters:{
			type:Object as PropType<SelectParams>,
			required:true
		}
	},
	components:{
		Container,
	},
	setup(props){

		const { translate } = useTranslate();

		const mode = computed({
			get:() => props.parameters.mode,
			set:(v) => set(props.parameters, "mode", v)
		});

		const options = computed(() => {

			return [
				{ value: "SelectOne", text: translate("assets.label.selectOne") }
			];
		})

		return {
			mode,
			options,
			translate,
		};
	}
});

